import Swal from 'sweetalert2';
import {
  FETCH_VOUCHER,
  SUBMIT_VOUCHER,
  DELETE_VOUCHER,
  REFRESH_VOUCHER_DATATABLES,
} from './_types';
import { API_URL, API_RESPONSE_STATUS, API_RESPONSE_MESSAGE, API_RESPONSE } from '../constants/env';
import { authApiHeader } from '../helpers/apiHeader';

export const fetchVoucher = () => {
  return (dispatch) => {
    return fetch(`${API_URL}/voucher`, {
      method: 'GET',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            dispatch({ type: FETCH_VOUCHER, result: response.data });
            break;

          case API_RESPONSE.FAILED:
          default:
            dispatch({ type: FETCH_VOUCHER, result: [] });
            Swal.fire('Fetch Voucher Failed', response[API_RESPONSE_MESSAGE], 'error');
        }
      });
  };
};

export const refreshVoucherDatatables = () => {
  return (dispatch) => {
    dispatch({ type: REFRESH_VOUCHER_DATATABLES });
  };
};

/**
 * @param data      voucher_code, payment_method_id, start_date, end_date, discount_type, discount_amount,
 *                  max_discount, min_order, quota
 */
export const submitVoucher = (data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/voucher`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_VOUCHER, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshVoucherDatatables()))
      .then(() => dispatch(fetchVoucher()));
  };
};

/**
 * @param id
 * @param data      voucher_code, payment_method_id, start_date, end_date, discount_type, discount_amount,
 *                  max_discount, min_order, quota
 */
export const updateVoucher = (id, data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/voucher/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_VOUCHER, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshVoucherDatatables()))
      .then(() => dispatch(fetchVoucher()));
  };
};

/**
 * @param id
 */
export const deleteVoucher = (id) => {
  return (dispatch) => {
    return fetch(`${API_URL}/voucher/${id}`, {
      method: 'DELETE',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Delete Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: DELETE_VOUCHER, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Delete Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshVoucherDatatables()))
      .then(() => dispatch(fetchVoucher()));
  };
};
